import Multiselect from 'vue-multiselect';
import { Doughnut } from 'vue-chartjs/legacy';
import { Bar } from 'vue-chartjs/legacy';
import axios from 'axios';

import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale, BarElement, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, BarElement, LinearScale);

import indicatorEscl from '../locales/es-CL/indicator.json';
import indicatorEsmx from '../locales/es-MX/indicator.json';
import indicatorEsco from '../locales/es-CO/indicator.json';
import indicatorEnus from '../locales/en-US/indicator.json';

export default {
  name: 'Indicator',
  components: {
    Multiselect,
    Doughnut,
    Bar,
  },
  i18n: {
    messages: {
      'es-CL': {
        indicator: indicatorEscl,
      },
      'es-MX': {
        indicator: indicatorEsmx,
      },
      'es-CO': {
        indicator: indicatorEsco,
      },
      'en-US': {
        indicator: indicatorEnus,
      },
    },
  },
  data() {
    return {
      activityDriverCompareDecrement: false,
      activityDriverCompareIncrement: false,
      perActivityDriverCompare: 0,
      totalEvent: 0,
      perItemCompare: 0,
      itemCompareIncrement: false,
      itemCompareDecrement: false,
      perActivityCompare: 0,
      activityCompareDecrement: false,
      activityCompareIncrement: false,
      eventCompareDecrement: false,
      routeCompareAssignationDecrement: false,
      routeCompareDecrement: false,
      eventCompareIncrement: false,
      perEventCompare: 0,
      routeCompareAssignationIncrement: false,
      routeCompareIncrement: false,
      perRouteAssignationCompare: 0,
      perRouteCompare: 0,
      totalActivityPlanned: 0,
      totalItemPlanned: 0,
      totalRouteAssignation: 0,
      totalRoute: 0,
      totalActivityDriver: 0,
      routeDriverList: [],
      indicatorData: [],
      indicatorDataCompare: [],
      month: null,
      optionsMonth: [],
      year: null,
      monthCompare: null,
      yearCompare: null,
      optionsYear: [],
      chartDataRoutePlannedRoute: {
        labels: [],
        datasets: [
          {
            backgroundColor: ['#D41EB9', '#6226F7', '#7E88E2'],
            data: [],
          },
        ],
      },
      chartDataRouteNotEnded: {
        labels: [],
        datasets: [
          {
            backgroundColor: ['#7E88E2', '#D41EB9'],
            data: [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
      },
      chartOptionsBar1: {
        responsive: true,
        maintainAspectRatio: true,
        indexAxis: 'y',
      },
      chartOptionsBar: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
      },
      chartDataBarEvents: {
        labels: [
          this.$t('indicator.label.eventDoor'),
          this.$t('indicator.label.eventDetention'),
          this.$t('indicator.label.eventSpeed'),
          this.$t('indicator.label.eventMaxSpeed'),
          this.$t('indicator.label.eventDisconnection'),
          this.$t('indicator.label.eventGps'),
          this.$t('indicator.label.eventOutOfRoute'),
          this.$t('indicator.label.eventInterference'),
          this.$t('indicator.label.eventPanic'),
        ],
        datasets: [
          {
            label: this.$t('indicator.label.events'),
            borderWidth: 1,
            borderColor: [
              'rgba(168, 222, 227, 10)',
              'rgba(204, 181, 251, 10)',
              'rgba(239, 179, 232, 10)',
              'rgba(247, 221, 180, 10)',
              'rgba(113, 196, 242, 10)',
              'rgba(175, 222, 248, 10)',
              'rgba(220, 220, 220, 10)',
              'rgba(238, 169, 229, 10)',
              'rgba(212, 30, 185, 10)',
            ],
            backgroundColor: [
              'rgba(168, 222, 227, 0.5)',
              'rgba(204, 181, 251, 0.5)',
              'rgba(239, 179, 232, 0.5)',
              'rgba(247, 221, 180, 0.5)',
              'rgba(113, 196, 242, 0.5)',
              'rgba(175, 222, 248, 0.5)',
              'rgba(220, 220, 220, 0.5)',
              'rgba(238, 169, 229, 0.5)',
              'rgba(212, 30, 185, 0.5)',
            ],
            data: [],
          },
        ],
      },
      chartDataBarActivity: {
        labels: [],
        datasets: [
          {
            label: this.$t('indicator.label.plannedActivity'),
            borderWidth: 1,
            borderColor: [
              'rgba(113, 196, 242, 10)',
              'rgba(175, 222, 248, 10)',
              'rgba(220, 220, 220, 10)',
              'rgba(238, 169, 229, 10)',
            ],
            backgroundColor: [
              'rgba(113, 196, 242, 0.5)',
              'rgba(175, 222, 248, 0.5)',
              'rgba(220, 220, 220, 0.5)',
              'rgba(238, 169, 229, 0.5)',
              'rgba(113, 196, 242, 0.5)',
            ],
            data: [],
          },
        ],
      },
      chartDataBarItem: {
        labels: [],
        datasets: [
          {
            label: this.$t('indicator.label.plannedItem'),
            borderWidth: 1,
            borderColor: [
              'rgba(168, 222, 227, 10)',
              'rgba(204, 181, 251, 10)',
              'rgba(239, 179, 232, 10)',
              'rgba(247, 221, 180, 10)',
            ],
            backgroundColor: [
              'rgba(168, 222, 227, 0.5)',
              'rgba(204, 181, 251, 0.5)',
              'rgba(239, 179, 232, 0.5)',
              'rgba(247, 221, 180, 0.5)',
              'rgba(113, 196, 242, 0.5)',
            ],
            data: [],
          },
        ],
      },
      chartDataBarDriver: {
        labels: [],
        datasets: [
          {
            label: [],
            borderWidth: 1,
            borderColor: [
              'rgba(168, 222, 227, 10)',
              'rgba(204, 181, 251, 10)',
              'rgba(239, 179, 232, 10)',
              'rgba(247, 221, 180, 10)',
            ],
            backgroundColor: [
              'rgba(168, 222, 227, 0.5)',
              'rgba(204, 181, 251, 0.5)',
              'rgba(239, 179, 232, 0.5)',
              'rgba(247, 221, 180, 0.5)',
              'rgba(113, 196, 242, 0.5)',
            ],
            data: [],
          },
        ],
      },
      chartDataActivityDriver: {
        labels: [],
        datasets: [
          {
            borderWidth: 1,
            backgroundColor: ['#6226F7', '#D41EB9'],
            data: [],
          },
        ],
      },
    };
  },
  async created() {
    this.prepareData();
  },
  methods: {
    async prepareData() {
      this.setYearOptions();
      this.setMonthOptions();
      this.setDateYearNow();
      this.setIndicatorGeneral();
    },
    async onChangeIndicator() {
      this.setChartClear();
      this.setDateYearCompare();
      this.setIndicatorGeneral();
    },
    async setIndicatorGeneral() {
      await this.getIndicatorData();
      await this.getIndicatorDataCompare();
      if (this.checkIndicator()) {
        this.setChartRoute();
        this.setChartRouteAssignation();
        this.setChartEvent();
        this.setChartActivity();
        this.setChartItem();
        await this.getDriversData();
        if (this.checkIndicatorTool()) {
          this.setChartDriver();
          this.setChartActivityDriver();
        }
      }
    },
    checkIndicatorTool() {
      if (this.indicatorData.toolIndicador.length === 0) {
        return false;
      }
      return true;
    },
    checkIndicator() {
      if (this.indicatorData.operationalIndicator != null) {
        return true;
      }
      return false;
    },
    setChartClear() {
      this.chartDataRoutePlannedRoute.datasets[0].data = [];
      this.chartDataRoutePlannedRoute.labels = [];
      this.chartDataRouteNotEnded.datasets[0].data = [];
      this.chartDataRouteNotEnded.labels = [];
      this.chartDataBarActivity.datasets[0].data = [];
      this.chartDataBarActivity.labels = [];
      this.chartDataBarItem.datasets[0].data = [];
      this.chartDataBarItem.labels = [];
      this.chartDataBarEvents.datasets[0].data = [];
      this.chartDataBarDriver.datasets[0].data = [];
      this.chartDataBarDriver.labels = [];
      this.chartDataActivityDriver.datasets[0].data = [];
      this.chartDataActivityDriver.labels = [];
      this.totalRouteAssignation = 0;
      this.totalRoute = 0;
      this.totalActivityDriver = 0;
      this.totalActivityPlanned = 0;
      this.totalItemPlanned = 0;
      this.totalEvent = 0;
      this.chartDataBarEvents.datasets[0].label = this.$t('indicator.label.events');
      this.clearCompare();
    },
    clearCompare() {
      this.eventCompareDecrement = false;
      this.routeCompareAssignationDecrement = false;
      this.routeCompareDecrement = false;
      this.eventCompareIncrement = false;
      this.routeCompareAssignationIncrement = false;
      this.routeCompareIncrement = false;
      this.activityCompareDecrement = false;
      this.activityCompareIncrement = false;
      this.itemCompareIncrement = false;
      this.itemCompareDecrement = false;
      this.activityDriverCompareDecrement = false;
      this.activityDriverCompareIncrement = false;
    },
    setChartRoute() {
      let totalRouteCompare = null;
      let routeEnded = this.indicatorData.operationalIndicator.indRouteEnded;
      let routeNotEnded = this.indicatorData.operationalIndicator.indRouteNotEnded;
      let routeEndedIncomplete = this.indicatorData.operationalIndicator.indRouteEndedIncomplete;
      this.totalRoute = routeEnded + routeNotEnded + routeEndedIncomplete;
      if (this.indicatorDataCompare.operationalIndicator) {
        totalRouteCompare =
          this.indicatorDataCompare.operationalIndicator.indRouteEnded +
          this.indicatorDataCompare.operationalIndicator.indRouteNotEnded +
          this.indicatorDataCompare.operationalIndicator.indRouteEndedIncomplete;
      }
      if (totalRouteCompare !== 0 && totalRouteCompare !== null) {
        if (totalRouteCompare > this.totalRoute) {
          this.routeCompareDecrement = true;
          let diff = totalRouteCompare - this.totalRoute;
          this.perRouteCompare = Math.round((diff / totalRouteCompare) * 100);
        } else {
          this.routeCompareIncrement = true;
          let diff = this.totalRoute - totalRouteCompare;
          this.perRouteCompare = Math.round((diff / totalRouteCompare) * 100);
        }
      }

      let perRouteEned = Math.round((routeEnded * 100) / this.totalRoute);
      let perRouteNotEnded = Math.round((routeNotEnded * 100) / this.totalRoute);
      let perRouteEndedIncomplete = Math.round((routeEndedIncomplete * 100) / this.totalRoute);

      this.chartDataRoutePlannedRoute.datasets[0].data.push(perRouteEned);
      this.chartDataRoutePlannedRoute.datasets[0].data.push(perRouteNotEnded);
      this.chartDataRoutePlannedRoute.datasets[0].data.push(perRouteEndedIncomplete);
      this.chartDataRoutePlannedRoute.labels.push(
        this.$t('indicator.label.ended') + ' ' + perRouteEned + '%' + '(' + routeEnded + ')',
      );
      this.chartDataRoutePlannedRoute.labels.push(
        this.$t('indicator.label.notEnded') + ' ' + perRouteNotEnded + '%' + '(' + routeNotEnded + ')',
      );
      this.chartDataRoutePlannedRoute.labels.push(
        this.$t('indicator.label.endedImcomplete') +
          ' ' +
          perRouteEndedIncomplete +
          '%' +
          '(' +
          routeEndedIncomplete +
          ')',
      );
    },
    setChartRouteAssignation() {
      let totalRouteAssignationCompare = null;
      let routeNotEnded = this.indicatorData.operationalIndicator.indRouteNotEnded;
      let routeNotEndedAssignation = this.indicatorData.operationalIndicator.indRouteNotEndedAssignation;
      this.totalRouteAssignation = routeNotEnded;
      let routeNotEndedNotAssignation = routeNotEnded - routeNotEndedAssignation;
      if (this.indicatorDataCompare.operationalIndicator) {
        totalRouteAssignationCompare = this.indicatorDataCompare.operationalIndicator.indRouteNotEnded;
      }
      if (totalRouteAssignationCompare !== 0 && totalRouteAssignationCompare !== null) {
        if (totalRouteAssignationCompare > this.totalRouteAssignation) {
          this.routeCompareAssignationDecrement = true;
          let diff = totalRouteAssignationCompare - this.totalRouteAssignation;
          this.perRouteAssignationCompare = Math.round((diff / totalRouteAssignationCompare) * 100);
        } else {
          this.routeCompareAssignationIncrement = true;
          let diff = this.totalRouteAssignation - totalRouteAssignationCompare;
          this.perRouteAssignationCompare = Math.round((diff / totalRouteAssignationCompare) * 100);
        }
      }

      let perRouteNotEnedNotAssignation = Math.round((routeNotEndedNotAssignation * 100) / this.totalRouteAssignation);
      let perRouteNotEndedAssignation = Math.round((routeNotEndedAssignation * 100) / this.totalRouteAssignation);

      this.chartDataRouteNotEnded.datasets[0].data.push(perRouteNotEnedNotAssignation);
      this.chartDataRouteNotEnded.datasets[0].data.push(perRouteNotEndedAssignation);

      this.chartDataRouteNotEnded.labels.push(
        this.$t('indicator.label.notAssignation') +
          ' ' +
          perRouteNotEnedNotAssignation +
          '%' +
          '(' +
          routeNotEndedNotAssignation +
          ')',
      );
      this.chartDataRouteNotEnded.labels.push(
        this.$t('indicator.label.assignation') +
          ' ' +
          perRouteNotEndedAssignation +
          '%' +
          '(' +
          routeNotEndedAssignation +
          ')',
      );
    },
    setChartEvent() {
      let totalEventCompare = null;
      this.totalEvent =
        this.indicatorData.operationalIndicator.indEventDoor +
        this.indicatorData.operationalIndicator.indEventDetention +
        this.indicatorData.operationalIndicator.indEventSpeed +
        this.indicatorData.operationalIndicator.indEventMaxSpeed +
        this.indicatorData.operationalIndicator.indEventDisconnection +
        this.indicatorData.operationalIndicator.indEventGps +
        this.indicatorData.operationalIndicator.indEventOutOfRoute +
        this.indicatorData.operationalIndicator.indEventInterference +
        this.indicatorData.operationalIndicator.indEventPanic;
      if (this.indicatorDataCompare.operationalIndicator) {
        totalEventCompare =
          this.indicatorDataCompare.operationalIndicator.indEventDoor +
          this.indicatorDataCompare.operationalIndicator.indEventDetention +
          this.indicatorDataCompare.operationalIndicator.indEventSpeed +
          this.indicatorDataCompare.operationalIndicator.indEventMaxSpeed +
          this.indicatorDataCompare.operationalIndicator.indEventDisconnection +
          this.indicatorDataCompare.operationalIndicator.indEventGps +
          this.indicatorDataCompare.operationalIndicator.indEventOutOfRoute +
          this.indicatorDataCompare.operationalIndicator.indEventInterference +
          this.indicatorDataCompare.operationalIndicator.indEventPanic;
      }
      if (totalEventCompare !== 0 && totalEventCompare !== null) {
        if (totalEventCompare > this.totalEvent) {
          this.eventCompareDecrement = true;
          let diff = totalEventCompare - this.totalEvent;
          this.perEventCompare = Math.round((diff / totalEventCompare) * 100);
        } else {
          this.eventCompareIncrement = true;
          let diff = this.totalEvent - totalEventCompare;
          this.perEventCompare = Math.round((diff / totalEventCompare) * 100);
        }
      }

      this.chartDataBarEvents.datasets[0].label = this.$t('indicator.label.events') + ':(' + this.totalEvent + ') ';
      this.chartDataBarEvents.datasets[0].data.push(this.indicatorData.operationalIndicator.indEventDoor);
      this.chartDataBarEvents.datasets[0].data.push(this.indicatorData.operationalIndicator.indEventDetention);
      this.chartDataBarEvents.datasets[0].data.push(this.indicatorData.operationalIndicator.indEventSpeed);
      this.chartDataBarEvents.datasets[0].data.push(this.indicatorData.operationalIndicator.indEventMaxSpeed);
      this.chartDataBarEvents.datasets[0].data.push(this.indicatorData.operationalIndicator.indEventDisconnection);
      this.chartDataBarEvents.datasets[0].data.push(this.indicatorData.operationalIndicator.indEventGps);
      this.chartDataBarEvents.datasets[0].data.push(this.indicatorData.operationalIndicator.indEventOutOfRoute);
      this.chartDataBarEvents.datasets[0].data.push(this.indicatorData.operationalIndicator.indEventInterference);
      this.chartDataBarEvents.datasets[0].data.push(this.indicatorData.operationalIndicator.indEventPanic);
    },
    setChartActivity() {
      let totalActivityCompare = null;
      let activityDone = this.indicatorData.operationalIndicator.indActivityDone;
      let activityNotDone = this.indicatorData.operationalIndicator.indActivityNotDone;
      let activityNotHandled = this.indicatorData.operationalIndicator.indActivityNotHandled;
      let activityPartiallyDone = this.indicatorData.operationalIndicator.indActivityPartiallyDone;
      this.totalActivityPlanned = activityDone + activityNotDone + activityNotHandled + activityPartiallyDone;

      if (this.indicatorDataCompare.operationalIndicator) {
        totalActivityCompare =
          this.indicatorDataCompare.operationalIndicator.indActivityDone +
          this.indicatorDataCompare.operationalIndicator.indActivityNotDone +
          this.indicatorDataCompare.operationalIndicator.indActivityNotHandled +
          this.indicatorDataCompare.operationalIndicator.indActivityPartiallyDone;
      }
      if (totalActivityCompare !== 0 && totalActivityCompare !== null) {
        if (totalActivityCompare > this.totalActivityPlanned) {
          this.activityCompareDecrement = true;
          let diff = totalActivityCompare - this.totalActivityPlanned;
          this.perActivityCompare = Math.round((diff / totalActivityCompare) * 100);
        } else {
          this.activityCompareIncrement = true;
          let diff = this.totalActivityPlanned - totalActivityCompare;
          this.perActivityCompare = Math.round((diff / totalActivityCompare) * 100);
        }
      }

      let perActivityDone = Math.round((activityDone * 100) / this.totalActivityPlanned);
      let perActivityNotDone = Math.round((activityNotDone * 100) / this.totalActivityPlanned);
      let perActivityNotHandled = Math.round((activityNotHandled * 100) / this.totalActivityPlanned);
      let perActivityPartiallyDone = Math.round((activityPartiallyDone * 100) / this.totalActivityPlanned);

      this.chartDataBarActivity.datasets[0].data.push(perActivityDone);
      this.chartDataBarActivity.datasets[0].data.push(perActivityNotDone);
      this.chartDataBarActivity.datasets[0].data.push(perActivityNotHandled);
      this.chartDataBarActivity.datasets[0].data.push(perActivityPartiallyDone);

      this.chartDataBarActivity.labels.push(
        this.$t('indicator.label.activityDone') + ' ' + perActivityDone + '%' + '(' + activityDone + ')',
      );
      this.chartDataBarActivity.labels.push(
        this.$t('indicator.label.activityNotDone') + ' ' + perActivityNotDone + '%' + '(' + activityNotDone + ')',
      );
      this.chartDataBarActivity.labels.push(
        this.$t('indicator.label.activityNotHandled') +
          ' ' +
          perActivityNotHandled +
          '%' +
          '(' +
          activityNotHandled +
          ')',
      );
      this.chartDataBarActivity.labels.push(
        this.$t('indicator.label.activityPartiallyDone') +
          ' ' +
          perActivityPartiallyDone +
          '%' +
          '(' +
          activityPartiallyDone +
          ')',
      );
    },
    setChartItem() {
      let totalItemCompare = null;
      let itemDone = this.indicatorData.operationalIndicator.indItemDone;
      let itemNotDone = this.indicatorData.operationalIndicator.indItemNotDone;
      let itemNotHandled = this.indicatorData.operationalIndicator.indItemNotHandled;
      let itemPartiallyDone = this.indicatorData.operationalIndicator.indItemPartiallyDone;
      this.totalItemPlanned = itemDone + itemNotDone + itemNotHandled + itemPartiallyDone;

      if (this.indicatorDataCompare.operationalIndicator) {
        totalItemCompare =
          this.indicatorDataCompare.operationalIndicator.indItemDone +
          this.indicatorDataCompare.operationalIndicator.indItemNotDone +
          this.indicatorDataCompare.operationalIndicator.indItemNotHandled +
          this.indicatorDataCompare.operationalIndicator.indItemPartiallyDone;
      }
      if (totalItemCompare !== 0 && totalItemCompare !== null) {
        if (totalItemCompare > this.totalItemPlanned) {
          this.itemCompareDecrement = true;
          let diff = totalItemCompare - this.totalItemPlanned;
          this.perItemCompare = Math.round((diff / totalItemCompare) * 100);
        } else {
          this.itemCompareIncrement = true;
          let diff = this.totalItemPlanned - totalItemCompare;
          this.perItemCompare = Math.round((diff / totalItemCompare) * 100);
        }
      }

      let perItemDone = Math.round((itemDone * 100) / this.totalItemPlanned);
      let perItemNotDone = Math.round((itemNotDone * 100) / this.totalItemPlanned);
      let perItemNotHandled = Math.round((itemNotHandled * 100) / this.totalItemPlanned);
      let perItemPartiallyDone = Math.round((itemPartiallyDone * 100) / this.totalItemPlanned);

      this.chartDataBarItem.datasets[0].data.push(perItemDone);
      this.chartDataBarItem.datasets[0].data.push(perItemNotDone);
      this.chartDataBarItem.datasets[0].data.push(perItemPartiallyDone);
      this.chartDataBarItem.datasets[0].data.push(perItemNotHandled);
      this.chartDataBarItem.labels.push(
        this.$t('indicator.label.itemDone') + ' ' + perItemDone + '%' + '(' + itemDone + ')',
      );
      this.chartDataBarItem.labels.push(
        this.$t('indicator.label.itemNotDone') + ' ' + perItemNotDone + '%' + '(' + itemNotDone + ')',
      );
      this.chartDataBarItem.labels.push(
        this.$t('indicator.label.itemPartiallyDone') + ' ' + perItemPartiallyDone + '%' + '(' + itemPartiallyDone + ')',
      );
      this.chartDataBarItem.labels.push(
        this.$t('indicator.label.itemNotHandled') + ' ' + perItemNotHandled + '%' + '(' + itemNotHandled + ')',
      );
    },
    setChartDriver() {
      this.indicatorData.toolIndicador.sort((a, b) =>
        a.indreceiver < b.indreceiver ? 1 : b.indreceiver < a.indreceiver ? -1 : 0,
      );
      for (let indicator of this.indicatorData.toolIndicador) {
        indicator.driverName = this.searchDriver(indicator.idDriver);
      }
      for (let i = 0; i < 10; i++) {
        if (i < this.indicatorData.toolIndicador.length && this.indicatorData.toolIndicador[i].indreceiver > 0) {
          this.chartDataBarDriver.labels.push(this.indicatorData.toolIndicador[i].driverName);
          this.chartDataBarDriver.datasets[0].data.push(this.indicatorData.toolIndicador[i].indreceiver);
        }
      }
    },
    setChartActivityDriver() {
      let totalActivityCompareDone = 0;
      let totalActivityCompareNotDone = 0;

      for (let indicatorDriver of this.indicatorDataCompare.toolIndicador) {
        totalActivityCompareDone += indicatorDriver.indActivityDone;
        totalActivityCompareDone += indicatorDriver.indActivityPartiallyDone;
        totalActivityCompareNotDone += indicatorDriver.indActivityNotDone;
        totalActivityCompareNotDone += indicatorDriver.indActivityNotHandled;
      }

      let totalActivityCompareDriver = totalActivityCompareDone + totalActivityCompareNotDone;

      let totalActivityDone = 0;
      let totalActivityNotDone = 0;
      for (let indicatorDriver of this.indicatorData.toolIndicador) {
        totalActivityDone += indicatorDriver.indActivityDone;
        totalActivityDone += indicatorDriver.indActivityPartiallyDone;
        totalActivityDone += indicatorDriver.indActivityNotDone;
        totalActivityNotDone += indicatorDriver.indActivityNotHandled;
      }
      this.totalActivityDriver = totalActivityDone + totalActivityNotDone;

      if (totalActivityCompareDriver !== 0 && totalActivityCompareDriver !== null) {
        if (totalActivityCompareDriver > this.totalActivityDriver) {
          this.activityDriverCompareDecrement = true;
          let diff = totalActivityCompareDriver - this.totalActivityDriver;
          this.perActivityDriverCompare = Math.round((diff / totalActivityCompareDriver) * 100);
        } else {
          this.activityDriverCompareIncrement = true;
          let diff = this.totalActivityDriver - totalActivityCompareDriver;
          this.perActivityDriverCompare = Math.round((diff / totalActivityCompareDriver) * 100);
        }
      }

      let perActivityDriverDone = Math.round((totalActivityDone * 100) / this.totalActivityDriver);
      let perActivityDriverNotDone = Math.round((totalActivityNotDone * 100) / this.totalActivityDriver);

      this.chartDataActivityDriver.datasets[0].data.push(perActivityDriverDone);
      this.chartDataActivityDriver.datasets[0].data.push(perActivityDriverNotDone);

      this.chartDataActivityDriver.labels.push(
        this.$t('indicator.label.activityDriverDone') +
          ' ' +
          perActivityDriverDone +
          '%' +
          '(' +
          totalActivityDone +
          ')',
      );
      this.chartDataActivityDriver.labels.push(
        this.$t('indicator.label.activityDriverNotDone') +
          ' ' +
          perActivityDriverNotDone +
          '%' +
          '(' +
          totalActivityNotDone +
          ')',
      );
    },
    searchDriver(id) {
      for (let driver of this.routeDriverList) {
        if (id === driver.id) {
          return driver.driverName;
        }
      }
      return '-';
    },
    async getDriversData() {
      const urlDrivers = `${this.$store.getters.urlAPI}/api/driver?provider=true`;

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        let driverPromise = await axios.get(urlDrivers, config);
        this.routeDriverList = driverPromise.data.data;
        this.routeDriverList.forEach((driver) => {
          driver.driverName = this.transformWords(driver.firstName) + ' ' + this.transformWords(driver.lastName);
        });
        console.log('DRIVERS ...', this.routeDriverList);
      } catch (e) {
        console.log(e);
      }
    },
    /**@author Nicolas Sepulveda
     * Metodo para transformar las palabras a capitalize,
     * Ejemplo: jOSue = Josue
     * @param {String} words
     * @returns
     */
    transformWords(words) {
      let listWords = words.split(' ');
      let finalWord = '';
      listWords.forEach((word) => {
        if (word) {
          if (finalWord == '') {
            finalWord = this.capitalize(word);
          } else {
            finalWord = finalWord + ' ' + this.capitalize(word);
          }
        }
      });
      return finalWord;
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    setYearOptions() {
      for (let i = 1900; i < 2100; i++) {
        let option = {
          id: i,
          name: i,
        };
        this.optionsYear.push(option);
      }
    },
    setMonthOptions() {
      this.optionsMonth.push({ name: this.$t('indicator.month.January'), id: 1 });
      this.optionsMonth.push({ name: this.$t('indicator.month.February'), id: 2 });
      this.optionsMonth.push({ name: this.$t('indicator.month.March'), id: 3 });
      this.optionsMonth.push({ name: this.$t('indicator.month.April'), id: 4 });
      this.optionsMonth.push({ name: this.$t('indicator.month.May'), id: 5 });
      this.optionsMonth.push({ name: this.$t('indicator.month.June'), id: 6 });
      this.optionsMonth.push({ name: this.$t('indicator.month.July'), id: 7 });
      this.optionsMonth.push({ name: this.$t('indicator.month.August'), id: 8 });
      this.optionsMonth.push({ name: this.$t('indicator.month.September'), id: 9 });
      this.optionsMonth.push({ name: this.$t('indicator.month.October'), id: 10 });
      this.optionsMonth.push({ name: this.$t('indicator.month.November'), id: 11 });
      this.optionsMonth.push({ name: this.$t('indicator.month.December'), id: 12 });
    },
    setDateYearNow() {
      let currentDate = new Date();
      this.month = this.setDateMonth(currentDate.getMonth());
      currentDate.setMonth(currentDate.getMonth() - 1);
      this.year = { id: currentDate.getFullYear(), name: currentDate.getFullYear() };
      currentDate.setMonth(currentDate.getMonth() - 1);
      this.monthCompare = this.setDateMonth(currentDate.getMonth() + 1);
      this.yearCompare = { id: currentDate.getFullYear(), name: currentDate.getFullYear() };
    },
    setDateYearCompare() {
      let selectDate = new Date();
      selectDate.setMonth(this.month.id - 1);
      selectDate.setFullYear(this.year.id);
      selectDate.setMonth(selectDate.getMonth() - 1);
      this.monthCompare = this.setDateMonth(selectDate.getMonth() + 1);
      this.yearCompare = { id: selectDate.getFullYear(), name: selectDate.getFullYear() };
    },
    setDateMonth(id) {
      for (let option of this.optionsMonth) {
        if (id === option.id) {
          return option;
        }
      }
    },
    async getIndicatorData() {
      const urlIndicator = `${this.$store.getters.urlAPI}/indicator?month=${this.month.id}&year=${this.year.id}`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await this.axios.get(urlIndicator, config);
        this.indicatorData = response.data.data;
      } catch (e) {
        console.log(e);
        this.indicatorData = [];
      }
    },
    async getIndicatorDataCompare() {
      const urlIndicator = `${this.$store.getters.urlAPI}/indicator?month=${this.monthCompare.id}&year=${this.yearCompare.id}`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await this.axios.get(urlIndicator, config);
        this.indicatorDataCompare = response.data.data;
      } catch (e) {
        console.log(e);
        this.indicatorDataCompare = [];
      }
    },
  },
  computed: {},
};
